import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.css'

export const ERROR_CLASS = '__input-validation-error'

class Input extends Component {
  static propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOfType([
      PropTypes.oneOf([
        'text',
        'email',
        'password',
        'search',
        'number',
        'textarea',
      ]),
      PropTypes.element,
      PropTypes.func,
    ]).isRequired,
    label: PropTypes.node,
    description: PropTypes.node,
    input: PropTypes.object,
    meta: PropTypes.object,
  }

  static defaultProps = {
    className: '',
    label: null,
    description: null,
    input: {},
    meta: {},
  }

  getClassName() {
    const { meta } = this.props

    return classnames(
      styles.root,
      {
        [styles.focused]: meta.active,
        [styles.faulty]: meta.touched && meta.error,
        [styles.required]: this.props.required, // eslint-disable-line react/prop-types
        [styles.disabled]: this.props.disabled, // eslint-disable-line react/prop-types
      },
      this.props.className,
    )
  }

  getInputElement() {
    const { type } = this.props
    if (typeof type === 'string') {
      return type === 'textarea' ? 'textarea' : 'input'
    }
    return type
  }

  getLabelElement() {
    return this.props.label ? 'label' : 'div'
  }

  render() {
    const {
      className,
      label,
      description,
      input,
      meta,
      type,

      ...restProps
    } = this.props

    const InputElement = this.getInputElement()
    const LabelElement = this.getLabelElement()

    return (
      <LabelElement className={this.getClassName()}>
        {label && <div className={styles.label}>{label}</div>}

        <InputElement
          type={typeof type === 'string' ? type : undefined}
          {...input}
          {...restProps}
        />

        {description && <div className={styles.description}>{description}</div>}

        {meta.touched &&
          meta.error && (
            <div className={classnames(styles.error, ERROR_CLASS)}>
              {meta.error}
            </div>
          )}
      </LabelElement>
    )
  }
}

export default Input



// WEBPACK FOOTER //
// ../source/components/Input/index.js